import { CurrencyExchangeDetailsPage } from 'features/currency-exchange';

export const AdminCurrencyExchangeDetailsPage: React.FC = () => (
  <CurrencyExchangeDetailsPage />
);
